
import React from 'react';

const GUTTER_SIZE = 5;

const DrawerPhotoListItemRenderer = ({ noBatch, noImage, classes, history, labelingTypePathname }) => ({ index, style, data }) => {
  const navigate = () => history.push(`/${labelingTypePathname}/${noBatch}/${index}`)
  const selected = Number(noImage) === index;
  return (
    <button
        style={{
          ...style,
          border: 'none',
          borderTop: selected ? '3px solid blue' : 'none',
          padding: selected ? '2px 0 0 0' : '0 0 0 0',
          left: style.left + GUTTER_SIZE,
          top: style.top + selected ? 0 : GUTTER_SIZE ,
          width: style.width - GUTTER_SIZE,
          height: style.height - GUTTER_SIZE,
          cursor: "pointer"          
        }}
        key={index}
        onClick={navigate}
      >
      <img src={data[index].url} alt="..." style={{ width: 'inherit', height: '145px', objectFit: 'cover' }}/>
    </button>
  );
}

export default DrawerPhotoListItemRenderer;
